<template>
  <div style="scale:93%">
  <v-row no-gutters justify="end">
    <span style="verical-align:middle" class="page-control-label">１ページ当たりの行数</span>
    <span style="width:120px" class="px-1 page-control-item">
      <v-select
        v-model="vItemsPerPage"
        :items="itemsPerPageItems"
        suffix="行"
        hide-details="auto"
        solo flat dense
        @input="changeItemsPerPage"
      />
    </span>
    <span style="verical-align:middle" class="page-control-label">ページ</span>
    <span style="width:80px" class="px-1 page-control-item">
      <v-select
        v-model="page"
        :items="pageItems"
        hide-details="auto"
        solo flat dense
        @input="changePage"
      />
    </span>
    <span style="verical-align:middle" class="page-control-label">／ {{ vMaxPage }}</span>
    <span class="ml-2" />
    <span style="padding-top:0px">
      <v-btn
        color="primary"
        class="zoom-hover mx-1"
        min-width="30"
        max-width="30px"
        width="30px"
        :disabled="page <= 1"
        @click="prevPage"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        class="zoom-hover mx-1"
        min-width="30"
        max-width="30px"
        width="30px"
        :disabled="items.length === 0 || page === maxPage"
        @click="nextPage"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </span>
  </v-row>
  </div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VSelect } from 'vuetify/lib'

/**
 * @file DDv2用単一ドロップダウン
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-select/
 * @example
  <dd-drop-down
    v-model="dropdown1value"
    :items="dropDownItems"
    :required="true"
    />
  data: () => ({
    dropDownItems: [
      { value: null, text: '' },
      { value: '0', text: 'Windows 3.1' },
      { value: '1', text: 'Windows 95' },
      { value: '2', text: 'Windows 98' },
      { value: '3', text: 'Windows 98 SE' },
      { value: '4', text: 'Windows 2000' },
      { value: '5', text: 'Windows Me' },
      { value: '6', text: 'Windows XP' },
      { value: '7', text: 'Windows Vista' },
      { value: '8', text: 'Windows 8' },
      { value: '9', text: 'Windows 10' }
    ]
  })
 */
export default {
  name: 'DdSelectItemsPerPage',
  extends: VSelect,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 表示行数
     */
    itemsPerPage: Number,
    /**
     * データ行数
     */
    items: Array,
    /**
     * 現在ページ
     */
    currentPage: Number
  },
  data: () => ({
    phtext: '選択して下さい',
    page: 1,
    vItemsPerPage: 50,
    vMaxPage: 1,
    invalidMessage: '',
    pageItems: [],
    itemsPerPageItems: [25, 50, 100, 200, 300, 500]
  }),
  created () {
  },
  mounted () {
    console.log('DdSelectItemsPerPage mounted', this.items)
    if (this.itemsPerPage) this.vItemsPerPage = this.itemsPerPage
    this.changeItemsPerPage()
  },
  watch: {
    items: function (e) {
      console.log(e)
      this.recalcPageList()
      this.page = 1
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    },
    maxPage () {
      if ([undefined, null, ''].includes(this.items)) return 1
      return Math.ceil(this.items.length / this.vItemsPerPage)
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    syncPagination: function (itemsPerPage, page) {
      this.vItemsPerPage = itemsPerPage
      this.vMaxPage = Math.ceil(this.items.length / itemsPerPage)
      // ページ再計算
      this.recalcPageList()
      this.page = page
    },
    recalcPageList: function () {
      console.log('DdSelectItemsPerPage recalcPageList', this.items)
      if (this.items) {
        this.vMaxPage = Math.ceil(this.items.length / this.vItemsPerPage)
        this.pageItems = []
        for (let i = 1; i <= this.vMaxPage; i++) {
          this.pageItems.push(i)
        }
        if (this.pageItems.length === 0) {
          this.pageItems.push(1)
          this.vMaxPage = 1
        } else {
          this.vMaxPage = Math.ceil(this.items.length / this.vItemsPerPage)
        }
      }
    },
    changeItemsPerPage: function () {
      // ページ計算
      this.recalcPageList()
      this.$emit('changeItemsPerPage', this.vItemsPerPage)
    },
    changePage: function () {
      this.$emit('changePage', this.page)
    },
    prevPage: function () {
      this.page--
      this.$emit('changePage', this.page)
    },
    nextPage: function () {
      this.page++
      this.$emit('changePage', this.page)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
::v-deep .v-select__selections input {
  max-width: 0px;
  max-height: 0px;
}
::v-deep .v-text-field__suffix {
  padding-top: 1px !important;
  padding-right: 2px !important;
}
.page-control-label {
    color: #1F2B38;
    float: right;
    padding-top: 8px;
}
.page-control-item {
    padding-top: 0px;
}
</style>
